import { useState } from 'react';
import { Switch, Spin } from 'antd';
import { consultationService } from "../../../services/medicalConsultation";

const SwitchReport = ({ record, setRefresh }) => {
  const [loading, setLoading] = useState(false);

  const enableReport = (id, checked) => {
    setLoading(true);
    consultationService
      .enableReport({ id, document_visibility: checked })
      .then(response => {
        setRefresh(Date.now());
      })
      .finally(() => setLoading(false));
  };

  return (
    <Spin spinning={loading}>
      <Switch
        className='cmt-switch'
        checked={record.document_visibility}
        onChange={(checked) => enableReport(record.id, checked)}
      />
    </Spin>
  )
}

export default SwitchReport;